import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import {
  CustomTab,
  DropdownToggle,
  PredefinedList,
  SelectedChips,
  Tabs,
} from './roles-input/roles-input.parts'
import { useRolesInput } from './roles-input/use-roles-input'

interface RolesInputProps {
  value: string[]
  onChange: (roles: string[]) => void
  existingCustomRoles?: string[]
}

export function RolesInput({
  value,
  onChange,
  existingCustomRoles = [],
}: RolesInputProps): ReactElement {
  const { t } = useTranslation('cases')
  const state = useRolesInput({ value, onChange, existingCustomRoles })

  return (
    <div className="space-y-2">
      <SelectedChips
        value={value}
        onRemove={(role) => {
          onChange(value.filter((item) => item !== role))
        }}
      />
      <div ref={state.dropdownRef} className="relative">
        <DropdownToggle
          isOpen={state.isOpen}
          selectedCount={value.length}
          onToggle={() => {
            state.setIsOpen(!state.isOpen)
          }}
          t={t}
        />
        {state.isOpen && (
          <div className="absolute z-50 mt-1 w-full rounded-md border border-slate-200 bg-white shadow-lg dark:border-slate-700 dark:bg-slate-800">
            <Tabs
              activeTab={state.activeTab}
              onSelect={state.setActiveTab}
              customCount={state.customRolesInUse.length}
              t={t}
            />
            <div className="max-h-52 overflow-y-auto">
              {state.activeTab === 'predefined' ? (
                <PredefinedList value={value} onToggle={state.toggleRole} />
              ) : (
                <CustomTab
                  value={value}
                  customRolesInUse={state.customRolesInUse}
                  customRole={state.customRole}
                  setCustomRole={state.setCustomRole}
                  onToggle={state.toggleRole}
                  onAddCustom={state.addCustomRole}
                  onCustomKeyDown={state.handleCustomKeyDown}
                  t={t}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
